import PromiseQueue from './promiseQueue'

const loadingImageQueue = new PromiseQueue({
  concurrent: 14,
  interval: 100,
  start: true
})

const loadingGalleryImageQueue = new PromiseQueue({
  concurrent: 14,
  interval: 100,
  start: true
})

export default loadingImageQueue

export { loadingGalleryImageQueue }